import './style.css';
import { createBuyer } from '../../api/create-buyer/create-buyer';
import React, { useState } from 'react';
import { Input, message } from 'antd';
import { useTranslation } from 'react-i18next';

const CreateBuyer = () => {
    const { t } = useTranslation();

    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('+7');

    const userType = 'Buyer';

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/[^+\d]/g, '');
        if (!value.startsWith('+7')) value = '+7';
        if (value.length > 12) value = value.slice(0, 12);
        setPhone(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const plainPhone = phone.startsWith('+') ? phone.slice(1) : phone;

        try {
            await createBuyer({
                name: name.trim(),
                lastname: lastname.trim(),
                password: password.trim(),
                email: null,
                phone: [plainPhone],
                userType,
            });

            message.success(t('created'));
            resetForm();
        } catch (err) {
            const msg = err?.response?.data?.msg || 'Произошла ошибка';
            message.error(msg);
            resetForm();
        }
    };

    const resetForm = () => {
        setName('');
        setLastname('');
        setPassword('');
        setPhone('+7');
    };

    const isDisabled = !name.trim() || phone.length < 12 || password.trim().length < 5;

    return (
        <div className="create-buyer">
            <h1 className="create-buyer-title">{t('createBauer')}</h1>

            <form onSubmit={handleSubmit} className="create-buyer-form">
                <Input
                    className="create-buyer-input"
                    type="text"
                    placeholder={t('writeName')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus
                />

                <Input
                    className="create-buyer-input"
                    type="text"
                    placeholder={t('writeSurname')}
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                />

                <Input
                    className="create-buyer-input"
                    type="tel"
                    placeholder="+7"
                    value={phone}
                    onChange={handlePhoneChange}
                />

                <Input.Password
                    className="create-buyer-input"
                    placeholder={t('createPassword')}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="create-buyer-btn" type="submit" disabled={isDisabled}>
                    {t('create')}
                </button>
            </form>
        </div>
    );
};

export default CreateBuyer;
